import { render } from "./ProductDetailsRelatedLinks.vue?vue&type=template&id=11d0aa09&ts=true"
import script from "./ProductDetailsRelatedLinks.vue?vue&type=script&lang=ts"
export * from "./ProductDetailsRelatedLinks.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Data\\TCF\\ABBp_PIS\\6.12\\PisNextGenExtTrain-PisApp_6_12_0\\PisNextGenExtTrain\\PisNextGen\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__